import * as Yup from 'yup';

export const shippingAddressFieldsValidator = (schema, shippingMethodName) =>
  schema.when([`shippingMethod_${shippingMethodName}_checkbox`, `shippingMethod_${shippingMethodName}_useDefaults`], { is: (isAddonChecked, isUseDefaults) => isAddonChecked && !isUseDefaults, then: Yup.string().required() })
